module.exports = require('./src/world.js')
module.exports.iterators = require('./src/iterators')
